class LightBox {
    constructor(selectors) {
        let defaultSelectors = {
            test: ".bi-arrows-fullscreen",
        };

        this.selectors = Object.assign(defaultSelectors, selectors);

        this.showBtns = document.querySelectorAll(this.selectors.test);

        if (this.showBtns)
            this.event();
    }

    event() {
        const lightBox = document.querySelector('.lightbox');

        this.showBtns.forEach(e => {
            e.addEventListener('click', (k) => {
                lightBox.style.display = "flex";
                document.querySelector('.lightbox img').setAttribute('src', e.nextElementSibling.src);
            })
        })

        if (lightBox) {
            lightBox.addEventListener('click', (e) => {
                lightBox.style.display = "none";
            })
        }
    }
}